import React, { FC } from 'react';

import { ToastTypeLogo } from './toast-type-logo';
import { Close, CloseLabel, Container, Message, MessageContainer, Wrapper } from './toast.styled';
import { IToastViewProps } from './types';

export const ToastView: FC<IToastViewProps> = ({ message: label, type, closeToast }) => (
  <Wrapper type={type}>
    <Container>
      <MessageContainer>
        <ToastTypeLogo type={type} />
        <Message>{label}</Message>
      </MessageContainer>
      <Close data-testid="closeToast" onClick={closeToast}>
        <CloseLabel />
      </Close>
    </Container>
  </Wrapper>
);
